<template>
<div>
  <el-row v-if="operationFlag" class="mr-b25">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div v-if="operationFlag" class="title-h4 dot-title">관심 서비스 포트 목록</div>
      <div>
        <w-header-search-button @click="onShowSearchToolButtonClickForMajor" />
      </div>
    </el-row>
    <el-row >
      <el-table-wrapper v-loading="majorLoading" ref="majorPortTable" :data="majorTableData" :columns="majorColumns" :show-overflow-tooltip="true"
        :show-custom-header="true" :show-search-tool="showSearchToolForMajor" :column-default="columnDefault" :pagination="true">
        <template #major-port-alive-slot="scope">
          <span v-if="scope.row['SERVICE_PORT/SERVICE_PORT_STATUS'] === '1'">
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                정상
              </span>
              <span :class="[$style['major-port-alive-check'], $style['major-port-status-up']]"></span>
            </el-tooltip>
          </span>
          <span v-else-if="scope.row['SERVICE_PORT/SERVICE_PORT_STATUS'] === '0'">
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                비정상
              </span>
              <span :class="[$style['major-port-alive-check'], $style['major-port-status-down']]"></span>
            </el-tooltip>
          </span>
          <span v-else>
            <el-tooltip effect="dark" placement="bottom">
              <span slot="content">
                미수집
              </span>
              <span :class="[$style['major-port-alive-check'], $style['major-port-status-null']]"></span>
            </el-tooltip>
          </span>
        </template>
      </el-table-wrapper>
    </el-row>
  </el-row>

  <el-row type="flex" class="title-bar" justify="space-between">
    <div v-if="operationFlag" class="title-h4 dot-title">서비스 포트 목록</div>
    <w-perf-analysis-time-info v-else :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
    <div>
      <w-tcp-udp-port-settings-button @reload="loadData" />
      <w-header-search-button @click="onShowSearchToolButtonClick" />
    </div>
  </el-row>
  <el-row>
    <el-table-wrapper v-loading="loading" ref="portTable" :data="tableData" :columns="columns"
      :row-class-name="getRowClassNameByMajorFlag" :show-custom-header="true" :show-search-tool="showSearchTool"
      :column-default="columnDefault" :show-overflow-tooltip="true" :pagination="true">
      <template slot-scope="scope" slot="auth-slot">
          <i :class="getAuthFlagStyle(scope.row.authFlag)"></i>
          {{ getAuthFlagLabel(scope.row.authFlag) }}
      </template>
      <template #port-alive-slot="scope">
        <span v-if="scope.row.portOpenStatusFlag === '1'">
          <el-tooltip effect="dark" placement="bottom">
            <span slot="content">
              정상
            </span>
            <span :class="[$style['major-port-alive-check'], $style['major-port-status-up']]"></span>
          </el-tooltip>
        </span>
        <span v-else>
          <el-tooltip effect="dark" placement="bottom">
            <span slot="content">
              비정상
            </span>
            <span :class="[$style['major-port-alive-check'], $style['major-port-status-down']]"></span>
          </el-tooltip>
        </span>
      </template>
    </el-table-wrapper>
  </el-row>
</div>
</template>
<script>
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import { isTrue } from '@/utils/boolean';
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { analysisTimeType } from '@/constants/performance';
import serverTableInfoAPI from '@/api/performance/server/info-table';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WTcpUdpPortSettingsButton from '@/views/performance/node/analysis/server/components/button/TcpUdpPortSettingsButton';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { convertMillisecondsToSeconds } from '@/utils/number';

export default {
  name: 'WTcpUdpPortTable',
  mixins: [analysisTableMixin],
  components: {
    WTcpUdpPortSettingsButton,
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      columnDefault,
      checkDatetime: null,
      tableData: [],
      majorTableData: [],
      columns: [
        {
          prop: 'portOpenStatusFlag',
          label: 'Listen 상태',
          sortable: true,
          filters: [
            {
              text: '정상',
              value: '1',
            },
            {
              text: '비정상',
              value: '0',
            },
          ],
          scopedSlot: 'port-alive-slot',
        },
        {
          prop: 'netProtocol',
          label: '프로토콜',
          sortable: true,
          filters: [
            {
              text: 'TCP',
              value: 'TCP',
            },
            {
              text: 'UDP',
              value: 'UDP',
            },
          ],
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netPortnum',
          label: '포트번호',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'serviceName',
          label: '서비스명',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'authFlag',
          label: '인증 상태',
          sortable: true,
          filters: [
            {
              text: '인증',
              value: 'Y',
            },
            {
              text: '비인증',
              value: 'N',
            },
          ],
          scopedSlot: 'auth-slot',
        },
      ],
      majorColumns: [
        {
          prop: 'SERVICE_PORT/SERVICE_PORT_STATUS',
          label: '동작상태',
          // searchable: true,
          sortable: true,
          scopedSlot: 'major-port-alive-slot',
          filters: [
            {
              text: '정상',
              value: '1',
            },
            {
              text: '비정상',
              value: '0',
            },
            {
              text: '미수집',
              value: null,
            },
          ],
        },
        {
          prop: 'netProtocol',
          label: '프로토콜',
          sortable: true,
          filters: [
            {
              text: 'TCP',
              value: 'TCP',
            },
            {
              text: 'UDP',
              value: 'UDP',
            },
          ],
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netPortnum',
          label: '포트번호',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'serviceName',
          label: '서비스명',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'SERVICE_PORT/SERVICE_PORT_RESPTIME',
          label: '응답시간(ms)',
          // sortable: true,
          formatter: this.convertMillisecondsValue,
        },
      ],
      loading: false,
      showSearchTool: false,
      showSearchToolForMajor: false,
      majorLoading: false,
    };
  },
  methods: {
    /**
     * 데이터를 조회한다.
     * 운영탭 - TCP/UDP 탭 조회의 경우에만 관심포트(+성능) 목록을 제공한다. (@author Song)
     *
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        this.loading = true;

        if (this.operationFlag) {
          this.majorLoading = true;
          serverTableInfoAPI
            .getCurrentMajorServicePortList(params)
            .then((response) => {
              if (response.data.success === true) {
                this.majorTableData = response.data.data;
              }
            })
            .catch(() => {
              this.failToLoad('major');
            })
            .finally(() => {
              this.majorLoading = false;
            });
        }

        // 포트 목록 조회
        serverTableInfoAPI
          .getCurrentTcpUdpPort(params)
          .then((response) => {
            if (response.data.success === true) {
              this.tableData = response.data.data;
            } else {
              this.failToLoad();
            }
          })
          .catch(() => {
            this.failToLoad('port');
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        // 이력의 경우 스냅샷 조회
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'SMS';
        serverTableInfoAPI
          .getTcpUdpPortSnapshot(params)
          .then((response) => {
            if (response.data.success === true) {
              const result = response.data.data;
              this.checkDatetime = result.timestamp;
              this.tableData = result.snapshotDoc;
            } else {
              this.failToLoad();
            }
          })
          .catch(() => {
            this.failToLoad();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    /**
     * 데이터 로드 실패 처리
     *
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad(type) {
      const target = type === 'major' ? '관심 포트' : 'TCP/UDP 포트';
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, target, false));
    },
    /**
     * 포트 동작 상태 formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForPortOpenStatusFlag(row, column, value) {
      if (isTrue(value)) {
        return '정상 동작';
      }
      return '비정상 동작';
    },
    /**
     * 인증 상태별 라벨을 반환한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getAuthFlagLabel(value) {
      if (!isTrue(value)) {
        return '비인증';
      }
      return '인증';
    },
    /**
     * 인증 상태에 대한 스타일을 반환한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getAuthFlagStyle(value) {
      if (!isTrue(value)) {
        return 'fas fa-key state-abnormal';
      }
      return 'fas fa-key state-normal';
    },
    /**
     * 헤더 검색 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    onShowSearchToolButtonClickForMajor() {
      this.showSearchToolForMajor = !this.showSearchToolForMajor;
    },
    /**
     * Row Class 반환
     * @author {Yang}
     * @param  {[type]} row      [description]
     * @param  {[type]} rowIndex [description]
     * @return {[String]}        [major data insert bgcolor]
     */
    getRowClassNameByMajorFlag({ row }) {
      if (isTrue(row.majorFlag)) {
        return 'table-point';
      }
      return '';
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 관심 포트 목록 - 응답시간 (ms) 단위 포맷
     * @author Song
     * @return {[type]} [description]
     */
    convertMillisecondsValue(row, column, value) {
      if (value < 0) {
        return EMPTY_TEXT;
      }
      return convertMillisecondsToSeconds(value);
    },
  },
};
</script>

<style module lang="scss">
.major-port-alive-check {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 10px;
}
.major-port-status-up {
  background-color: rgb(92, 189, 95);
}
.major-port-status-down {
  background-color: rgb(255, 78, 94);
}
.major-port-status-null {
  background-color: #b1aaab;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/components/table/TcpUdpPortTable.vue